import { size } from "polished";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import FooterLogo from "../img/client-logo.svg?react";
import Facebook from "../img/icons/social/facebook.svg";
import Instagram from "../img/icons/social/instagram.svg";
import LinkedIn from "../img/icons/social/linkedin.svg";
import X from "../img/icons/social/x.svg";

const StyledFooter = styled.footer`
  padding-top: ${({ theme }) => theme.space[6]};
  padding-bottom: ${({ theme }) => theme.space[0]};
  background-color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.fonts.base};
  font-size: ${({ theme }) => theme.fontSizes[2]};
  font-weight: 600;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[1]};
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.space[6]};

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    gap: 0;
  }
`;

const LogoContainer = styled.div`
  width: auto;
  height: auto;
  margin: auto;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    margin-inline-start: 0;
  }
`;

const Logo = styled(FooterLogo)`
  ${size(110, 111)}

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    ${size(150, 141)}
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Copyright = styled.div`
  color: ${({ theme }) => theme.colors.greyLight2};
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    text-align: start;
  }
`;

const SocialIconsWrapper = styled.ul`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.space[4]};
  padding: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints[3]}) {
    justify-content: start;
    gap: ${({ theme }) => theme.space[6]};
  }

  > li {
    list-style: none;
  }
`;

const SocialIcon = styled.img`
  width: 2.6rem;
  height: 2.6rem;
  cursor: pointer;
`;

const SocialMedia = [
  {
    name: "Facebook",
    icon: Facebook,
    link: "https://www.facebook.com/ligaportugal",
  },
  {
    name: "Instagram",
    icon: Instagram,
    link: "https://www.instagram.com/ligaportugal/",
  },
  {
    name: "X",
    icon: X,
    link: "https://x.com/ligaportugal",
  },
  {
    name: "Linkedin",
    icon: LinkedIn,
    link: "https://www.linkedin.com/company/ligaportugal",
  },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <StyledFooter>
      <Inner>
        <LogoContainer>
          <Logo />
        </LogoContainer>
        <ContentWrapper>
          <Copyright>
            <p>
              {t(
                "footer.copyright",
                "All rights reserved © 2026 Liga Portuguesa de Futebol Profissional",
              )}
            </p>
          </Copyright>
          <SocialIconsWrapper>
            {SocialMedia.map((item, name) => (
              <li key={name}>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  <SocialIcon src={item.icon} alt={item.name} />
                </a>
              </li>
            ))}
          </SocialIconsWrapper>
        </ContentWrapper>
      </Inner>
    </StyledFooter>
  );
};

export default Footer;
